import styled from "styled-components";

export const MapContainer = styled.div`
    height: 300px;
    width: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    overflow: hidden;
    margin: 16px 0;
    background-color: #f5f5f5;

    /* GoogleMapReact konteynerini kesinlikle görünür yap */
    & > div {
        height: 100% !important;
        width: 100% !important;
    }
`;
